import React, { useContext } from 'react';
import { ModalContext } from '../../../contexts/modalContext';
import { LogInContext } from '../../../contexts/logInContext';
import { ModalWrapper, RemoveModalWrapper } from '../Modals.styles';
import { ModalCreateButtons } from '../ModalButtons';
import { SchoolToggleStatus } from '../../../api';
import { SchoolsContext } from '../../../contexts/schoolsContext';

const ApproveSchoolModal = ({ modalRef, closeModal }) => {
  const { school } = useContext(SchoolsContext);
  const { showModal, setShowModal } = useContext(ModalContext);
  const { token } = useContext(LogInContext);

  const handleApproveStudent = async () => {
    const res = await SchoolToggleStatus(school?.school?.id, token);

    if (res.status === 'success') {
        setShowModal(false);
    }
  };

  return (
    <>
      {showModal && (
        <ModalWrapper ref={modalRef} onClick={closeModal}>
          <RemoveModalWrapper>
            <h3>Are you sure you want to approve {school?.school?.name}? </h3>
            <ModalCreateButtons
              text="Save Changes"
              onClick={handleApproveStudent}
            />
          </RemoveModalWrapper>
        </ModalWrapper>
      )}
    </>
  );
};

export default ApproveSchoolModal;
